/**
 * Panel catalog — popular AU-market PV modules.
 *
 * Picker fills all spec values from a single click. Users can hand-edit
 * if their specific batch differs from the published datasheet.
 *
 * Fields map 1:1 onto topology.panels (PanelModel).
 */

import type { PanelModel } from '../types/topology';

export interface PanelCatalogEntry extends PanelModel {
  /** Optional short note (e.g. "TOPCon", "N-type", "Bifacial"). */
  note?: string;
}

export const PANEL_CATALOG: PanelCatalogEntry[] = [
  // ----- Jinko Solar -----
  { manufacturer: 'Jinko Solar', model: 'JKM410M-54HL4-V',  pmax: 410, voc: 37.45, vmp: 31.34, isc: 13.84, imp: 13.08, fuseRating: 20, note: 'Tiger Pro 54-cell' },
  { manufacturer: 'Jinko Solar', model: 'JKM440N-54HL4R-V', pmax: 440, voc: 38.65, vmp: 32.33, isc: 14.29, imp: 13.61, fuseRating: 20, note: 'Tiger Neo N-type' },
  { manufacturer: 'Jinko Solar', model: 'JKM475N-60HL4',    pmax: 475, voc: 42.88, vmp: 36.02, isc: 14.11, imp: 13.19, fuseRating: 20, note: 'Tiger Neo 60-cell' },
  { manufacturer: 'Jinko Solar', model: 'JKM575N-72HL4',    pmax: 575, voc: 51.85, vmp: 43.10, isc: 14.40, imp: 13.34, fuseRating: 20, note: 'Tiger Neo bifacial' },
  { manufacturer: 'Jinko Solar', model: 'JKMS315PP-72',     pmax: 315, voc: 36.89, vmp: 29.86, isc: 11.26, imp: 8.26,  fuseRating: 12, note: 'Legacy poly 72-cell' },

  // ----- Longi Solar -----
  { manufacturer: 'Longi Solar', model: 'LR5-54HTH-440M',   pmax: 440, voc: 41.80, vmp: 34.65, isc: 13.47, imp: 12.70, fuseRating: 20, note: 'Hi-MO 6 Explorer' },
  { manufacturer: 'Longi Solar', model: 'LR5-72HTH-555M',   pmax: 555, voc: 50.20, vmp: 41.85, isc: 14.05, imp: 13.27, fuseRating: 25, note: 'Hi-MO 6 Explorer' },
  { manufacturer: 'Longi Solar', model: 'LR4-72HBD-455M',   pmax: 455, voc: 49.50, vmp: 41.30, isc: 11.65, imp: 11.02, fuseRating: 20, note: 'Hi-MO 4 bifacial' },

  // ----- JA Solar -----
  { manufacturer: 'JA Solar',    model: 'JAM72D40-580/MB',  pmax: 580, voc: 51.85, vmp: 43.68, isc: 14.30, imp: 13.28, fuseRating: 20, note: 'DeepBlue 4.0 N-type' },
  { manufacturer: 'JA Solar',    model: 'JAM72S30-555/MR',  pmax: 555, voc: 50.05, vmp: 41.95, isc: 14.04, imp: 13.23, fuseRating: 20 },
  { manufacturer: 'JA Solar',    model: 'JAM54S31-440/MR',  pmax: 440, voc: 41.45, vmp: 34.55, isc: 13.45, imp: 12.74, fuseRating: 20 },

  // ----- Trina Solar -----
  { manufacturer: 'Trina Solar', model: 'TSM-NEG21C.20-670', pmax: 670, voc: 46.50, vmp: 38.70, isc: 18.36, imp: 17.32, fuseRating: 25, note: 'Vertex N-type 670W' },
  { manufacturer: 'Trina Solar', model: 'TSM-DE19R.08-585',  pmax: 585, voc: 53.60, vmp: 45.10, isc: 13.95, imp: 12.97, fuseRating: 20, note: 'Vertex S+' },

  // ----- Canadian Solar / REC / SunPower -----
  { manufacturer: 'Canadian Solar', model: 'HiKu7 CS7N-MS-650', pmax: 650, voc: 45.90, vmp: 38.60, isc: 18.05, imp: 16.84, fuseRating: 25 },
  { manufacturer: 'REC',            model: 'Alpha Pure-R 430W', pmax: 430, voc: 39.90, vmp: 33.30, isc: 13.50, imp: 12.92, fuseRating: 25 },
  { manufacturer: 'SunPower',       model: 'M Series 440W',     pmax: 440, voc: 41.10, vmp: 34.80, isc: 14.00, imp: 13.10, fuseRating: 20, note: 'Maxeon back-contact' },
];
